// eslint-disable-next-line import/no-unresolved
import mesConfig from 'mesConfig';

const defaultConfig = {
  modules: {
    enableBatchHandling: false,
    enableBatchQueue: false,
    enableInspectionLotImport: false,
    enableInspectionManagement: false,
    enableInspectionReport: false,
    enableKpiExport: false,
    enableManualFinalPerformanceReporting: false,
    enableManualSensorDataRecording: false,
    enableOrderProgress: false,
    enableYields: false,
  },

  interruptionTags: {},

  /*
   * The language in which the frontend is rendered.
   * Available values: 'de', 'en'
   */
  language: 'en',

  /*
   * token for guest-login. If undefined, guest-session is disabled.
   */
  guestLoginToken: undefined,

  /*
   * time in seconds after which the user gets logged out if they are inactive. 0 to disable.
   */
  logoutAfterInactivity: 0,

  enableExperimental: false,

  corporateIdentity: {
    /*
     * The highlight color of various UI elements.
     * Currently, changes to this this will only apply on a frontend rebuild, since it's compiled into CSS via LESS
     */
    aspectColor: '#1890FF',

    /*
     * The background color of the top navigation bar
     */
    navbarColor: '#FFFFFF',

    /*
     * A URL to the logo displayed in the navigation bar.
     */
    image: '/logo.png',
  },

  mqtt: {
    useBackendProxy: false,
    host: null,
    port: 3090,
    username: null,
    password: null,
    disableOfflineIndicator: false,
  },
};

const appConfig = {
  ...defaultConfig,
  ...mesConfig,
  modules: {
    ...defaultConfig.modules,
    ...mesConfig.modules,
  },
  corporateIdentity: {
    ...defaultConfig.corporateIdentity,
    ...mesConfig.corporateIdentity,
  },
  mqtt: {
    ...defaultConfig.mqtt,
    ...mesConfig.mqtt,
  },
};

/**
 * Import this in your components to access the static configuration located in the MesConfig resource of the backend
 */
export default appConfig;
